.ux-iws-slider-slide-zoomable {
    display: block;
    overflow: hidden;
    box-sizing: border-box;
    position: relative !important;
}
